import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Avatar } from '@/ui/primitives/Avatar';
import { useChatConfig, useChatState } from '@/ui/ChatProvider';
/** How long each status line stays up. Ten lines at this pace cover ~35s. */
const STEP_INTERVAL_MS = 3500;
export function TypingIndicator() {
    const { branding, copy, serverStatus } = useChatConfig();
    const stage = useChatState((s) => s.agentStatus);
    const serverText = useChatState((s) => s.agentStatusText);
    const steps = copy.progressSteps;
    const [index, setIndex] = useState(0);
    // The last live line, held while a stage with no wording passes through.
    const [liveLine, setLiveLine] = useState();
    // The server's own line first: it knows what is happening ("Checking net
    // sales by month…"). The widget's wording per stage when it sends none.
    const live = (serverStatus !== false && serverText) || (stage ? copy.statusStages[stage] : undefined);
    useEffect(() => {
        if (live)
            setLiveLine(live);
    }, [live]);
    // Without live status (a backend that does not stream), advance through the
    // canned lines once and hold on the last, so a slow reply never appears to
    // start over. Live status replaces them from its first update.
    useEffect(() => {
        if (liveLine || index >= steps.length - 1)
            return;
        const id = window.setTimeout(() => setIndex((i) => i + 1), STEP_INTERVAL_MS);
        return () => window.clearTimeout(id);
    }, [liveLine, index, steps.length]);
    const step = liveLine ?? steps[Math.min(index, steps.length - 1)];
    return (_jsxs("div", { className: "ac-message", "data-role": "assistant", children: [_jsx(Avatar, { name: branding.name, src: branding.avatarUrl, size: "sm" }), _jsx("div", { className: "ac-message-body", children: _jsxs("div", { className: "ac-bubble", "aria-live": "polite", children: [_jsx("span", { className: "ac-sr-only", children: `${branding.name} ${copy.typing}` }), _jsxs("div", { className: "ac-typing-status", "aria-hidden": "true", children: [step && _jsx("span", { className: "ac-typing-step", children: step }, step), _jsxs("div", { className: "ac-typing", children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {})] })] })] }) })] }));
}
